(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2658],{

/***/ 48400:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-in/[page]",
      function () {
        return __webpack_require__(56160);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _pages_new_in__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19738);

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (_pages_new_in__WEBPACK_IMPORTED_MODULE_0__["default"]);


/***/ }),

/***/ 19738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ NewInPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _imports_category_page__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54725);
/* harmony import */ var _unlikelystudio_react_abstract_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92665);
/* harmony import */ var _components_PageViewAnalytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68971);
/* harmony import */ var _components_PageWithFilters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5560);
/* harmony import */ var _components_UI_HeroCategory__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89811);









var __N_SSG = true;
function NewInPage(_param) {
    var slices = _param.slices, heroData = _param.heroData, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "slices",
        "heroData"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_HeroCategory__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, heroData)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PageWithFilters__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_unlikelystudio_react_abstract_components__WEBPACK_IMPORTED_MODULE_8__/* .SliceManager */ .y, {
                    mapSliceTypeToComponent: _imports_category_page__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
                    slicesData: slices
                })
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PageViewAnalytics__WEBPACK_IMPORTED_MODULE_2__/* .PageViewAnalytics */ .W, {
                template: "page"
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7924,7130,565,2873,3816,5750,6169,4109,7421,5672,9774,2888,179], function() { return __webpack_exec__(48400); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);